import { computed, ref } from 'vue';
import api from '@core/services/api/_api';
import ApplicationsBusinessInfo from '@core/classes/Applications/ApplicationsBusinessInfo';
import { defineStore } from 'pinia';
import moment from 'moment';

export const useBusinessStore = defineStore('business', () => {
	// State
	const business = ref(null);

	// Getter
	const getBusiness = computed(() => business.value);
	const formattedBusinessStartDate = computed(() => {
		return business.value?.businessInfo?.businessStartDate ? moment(business.value.businessInfo.businessStartDate).format('MM/DD/YYYY') : '';
	});

	// Actions
	const getBusinessInformationFromBackend = async (id: string) => {
		try {
			const response = await api.customerPortal.getBusinessInformation(id);
			if (response && response?.status === 200 && response.data) {
				setBusiness(response.data.payload.businessInfo);
			}
		} catch (error) {
			console.error(error, 'Error retrieving Business information');
			clearBusiness();
		}
	};

	const clearBusiness = () => {
		business.value = {};
	};

	const setBusiness = (newBusiness: any) => {
		business.value = newBusiness;
	};

	const getBusinessFormData = computed(() => {
		if (!business.value) return null;

		return {
			legalName: business.value.legalName ?? '',
			entityType: business.value.entityType ?? null,
			phoneNumber: business.value.phoneNumber ?? '',
			businessStartDate: business.value.businessStartDate ?? '',
		};
	});

	return {
		business,
		getBusinessInformationFromBackend,
		getBusiness,
		getBusinessFormData,
		formattedBusinessStartDate,
		clearBusiness,
		setBusiness,
	};
});
